import React from 'react';
import { SVGProps } from 'react';

export const SvgMtsLogoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        {...props}
    >
        <path fill="#FF0032" d="M.667.667h30.667v30.667H.667z" />
        <path
            fill="#fff"
            d="M21.32 2.438v1.493h3.216v5.937h1.801V3.931h3.216V2.438H21.32ZM9.738 2.46 7.385 7.346 5.033 2.46H2.465v7.384h1.8V4.56l2.3 4.465h1.641l2.3-4.465v5.285h1.8V2.461H9.738ZM27.748 27.076a1.226 1.226 0 0 1-.352.72c-.203.184-.452.31-.72.363a5.703 5.703 0 0 1-1.192.108 3.905 3.905 0 0 1-1.256-.184 1.565 1.565 0 0 1-.815-.615c-.196-.29-.293-.71-.293-1.243v-.757c0-.537.099-.957.293-1.247.195-.29.481-.506.813-.614.406-.13.83-.192 1.256-.184.4-.006.8.03 1.192.108.268.053.517.179.72.363.195.194.319.447.352.72h1.802a2.62 2.62 0 0 0-.617-1.544 2.82 2.82 0 0 0-1.353-.826 7.62 7.62 0 0 0-2.095-.25c-.863 0-1.612.124-2.225.368a2.842 2.842 0 0 0-1.44 1.232c-.317.545-.484 1.272-.495 2.165v.081l.096.004h-.096v.082c.01.892.178 1.62.495 2.165.325.563.833.998 1.44 1.231.614.245 1.363.37 2.225.37a7.596 7.596 0 0 0 2.095-.251 2.81 2.81 0 0 0 1.353-.826c.368-.434.585-.976.617-1.544l-1.8.005Z"
        />
        <path
            stroke="#FF0032"
            strokeWidth={1.333}
            d="M.667.667h30.667v30.667H.667z"
        />
    </svg>
);
